<template>
	<div class="page yarns-archive">
		<section id="navigation">
			<div class="container">
				<div class="content flex">
					<span @click="$router.go(-1);" class="go-back">
						<svg
							class="navigation-icon link-icon small"
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 14 20"
						>
							<path d="M.8 10L10.36.44 13.2 3.3 6.5 10l6.72 6.7-2.85 2.85L.8 10z" />
						</svg>
					</span>
					<svg class="navigation-icon left" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
						<path
							d="M19 3H5C3.88 3 3 3.9 3 5V19a1.99 1.99 0 0 0 1.99 2h14c1.1 0 2-.9 2-2V5a2 2 0 0 0-2-2zm0 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3H5V5h14v10z"
						/>
					</svg>
					<span class="navigation-title">{{$t('yarns-archive')}}</span>
					<div class="navigation-right">
						<div>
							<svg @click="reload()" class="navigation-icon link-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path data-v-4e3d3c40="" data-v-3b2641f0="" data-v-c6c5ef5c="" d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"></path></svg>
						</div>
					</div>
				</div>
			</div>
		</section>
		<transition name="slide-up" mode="out-in" appear>
			<section class="main no-padding-top" :key="$route.params.id">
				<FilteredSearch
					:loaded="true"
					:list="yarns"
					:click="yarnClick"
					:customText="yarnText"
					:placeholder="$t('search')"
					:filterAttributes="filterAttributes"
					:deleteAction="deleteAction">
					<template #content="{item}">
						<div class="list-link-inner-text">
							{{yarnText(item)}}
							<span class="filtered" v-html="item.text"></span>
						</div>
						<div class="list-link-inner">
							<svg v-if="localCloudIcon(item)" class="list-link-icon" height="512pt" viewBox="0 -22 512.00002 512" width="512pt" xmlns="http://www.w3.org/2000/svg"><path d="m463.285156 0h-337.054687c-4.199219 0-7.605469 3.40625-7.605469 7.605469s3.40625 7.601562 7.605469 7.601562h337.054687c18.476563 0 33.507813 15.03125 33.507813 33.503907v270.589843c0 18.476563-15.03125 33.503907-33.507813 33.503907h-414.574218c-18.472657 0-33.503907-15.027344-33.503907-33.503907v-270.589843c0-18.472657 15.03125-33.503907 33.503907-33.503907h47.101562c4.199219 0 7.605469-3.402343 7.605469-7.601562s-3.40625-7.605469-7.605469-7.605469h-47.101562c-26.859376 0-48.710938 21.851562-48.710938 48.710938v270.589843c0 26.859375 21.851562 48.710938 48.710938 48.710938h122.273437l-14.894531 48.667969h-27.921875c-14.257813 0-25.851563 11.597656-25.851563 25.851562 0 14.257812 11.59375 25.851562 25.851563 25.851562h255.664062c14.253907 0 25.851563-11.59375 25.851563-25.851562 0-14.253906-11.597656-25.851562-25.851563-25.851562h-27.921875l-14.894531-48.667969h122.269531c26.863282 0 48.714844-21.851563 48.714844-48.710938v-270.589843c0-26.859376-21.851562-48.710938-48.714844-48.710938zm-68.808594 442.535156c0 5.867188-4.777343 10.644532-10.644531 10.644532h-255.664062c-5.871094 0-10.644531-4.777344-10.644531-10.644532 0-5.871094 4.773437-10.644531 10.644531-10.644531h255.664062c5.867188 0 10.644531 4.773437 10.644531 10.644531zm-54.472656-25.855468h-168.007812l14.890625-48.664063h138.226562zm0 0"/><path d="m463.84375 247.53125c4.203125 0 7.605469-3.40625 7.605469-7.605469v-191.210937c0-4.503906-3.660157-8.164063-8.164063-8.164063h-414.578125c-4.492187 0-8.148437 3.660157-8.148437 8.164063v247.828125c0 4.199219 3.402344 7.601562 7.601562 7.601562h415.683594c4.203125 0 7.605469-3.402343 7.605469-7.601562v-26.199219c0-4.199219-3.402344-7.601562-7.605469-7.601562-4.199219 0-7.601562 3.402343-7.601562 7.601562v18.59375h-400.476563v-233.179688h400.476563v184.167969c0 4.203125 3.402343 7.605469 7.601562 7.605469zm0 0"/><path d="m262.320312 322.894531c-1.664062-2.53125-4.84375-3.828125-7.808593-3.234375-3.242188.648438-5.761719 3.421875-6.074219 6.71875-.65625 6.875 7.84375 11.011719 12.832031 6.222656 2.632813-2.53125 3.054688-6.667968 1.050781-9.707031zm0 0"/></svg>
							<svg v-if="!localCloudIcon(item)" class="list-link-icon" height="512pt" viewBox="-20 -129 638.67144 638" width="638pt" xmlns="http://www.w3.org/2000/svg"><path d="m478.90625 132.8125c-4.785156.003906-9.5625.292969-14.3125.863281-12.894531-41.988281-51.628906-70.683593-95.550781-70.773437-10.933594-.011719-21.789063 1.804687-32.121094 5.363281-25.578125-55.308594-86.195313-85.367187-145.699219-72.25-59.511718 13.121094-101.867187 65.875-101.824218 126.808594.003906 10.53125 1.316406 21.019531 3.890624 31.222656-56.695312 8.65625-97.203124 59.46875-92.988281 116.667969 4.207031 57.203125 51.71875 101.542968 109.070313 101.796875h369.535156c66.191406 0 119.847656-53.660157 119.847656-119.851563s-53.65625-119.847656-119.847656-119.847656zm0 219.722656h-369.535156c-49.238282.214844-89.472656-39.253906-90.207032-88.488281-.730468-49.234375 38.304688-89.878906 87.53125-91.132813 3.195313-.089843 6.152344-1.703124 7.957032-4.339843 1.8125-2.640625 2.246094-5.980469 1.171875-8.992188-19.824219-56.730469 9.664062-118.855469 66.152343-139.367187 56.484376-20.511719 118.964844 8.226562 140.15625 64.460937.96875 2.609375 2.976563 4.691407 5.546876 5.753907 2.574218 1.0625 5.46875 1.003906 7.992187-.160157 10.457031-4.863281 21.84375-7.382812 33.371094-7.394531 38 .070312 70.722656 26.835938 78.3125 64.070312 1.085937 5.414063 6.359375 8.914063 11.765625 7.820313 6.511718-1.304687 13.136718-1.96875 19.785156-1.976563 55.160156 0 99.875 44.71875 99.875 99.871094 0 55.160156-44.714844 99.875-99.875 99.875zm0 0"/></svg>
						<svg class="list-link-icon link-icon arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 20"><path d="M.8 10L10.36.44 13.2 3.3 6.5 10l6.72 6.7-2.85 2.85L.8 10z"/></svg>
						</div>
						</template>
				</FilteredSearch>
			</section>
		</transition>
	</div>
</template>

<script>
import FilteredSearch from '@/components/FilteredSearch.vue';
import { mapState } from "vuex";

export default {
	data() {
		return {
			componentToReload: 0,
			//yarns: [...this.$store.getters.getYarnsArchive],
			// computedYarns: [],
			filterAttributes: [
				{ attribute: 'data.yarnName', text: this.$t('name') },
				// {attribute: 'data.yarnType', text: this.$t('yarn-type')},
				{
					attribute: 'data.needlesNumber',
					text: this.$t('needles-number')
				},
				{ attribute: 'result.yarnCount', text: this.$t('yarn-count') }
			]
		};
	},
	computed: {
		...mapState(['app']),
		yarns() {
			return ([...this.app.yarnsArchive]).sort((a,b) => (a.timestamp > b.timestamp ? -1 : ((a.timestamp < b.timestamp) ? 1 : 0)))
		}
	},
	methods: {
		localCloudIcon(item){
			let rst = false;
			if(item.saved === 'local') rst = true;
			return rst;
		},
		reload(){
			this.$store.dispatch('updateYarnsArchive');
			this.componentToReload += 1;
		},
		yarnClick(item, index) {
			this.$router.push({ name: 'yarn', params: { id: item.id, type: item.saved } });
		},
		yarnText(item) {
			return `${item.data.yarnName}`;
		},
		deleteAction(selected) {
			return new Promise((resolve, reject) => {
				let self = this;
				let localYarnsIds = selected.filter(o => {
					return o.saved === 'local';
				}).map(o => o.id);
				let cloudYarnsIds = selected.filter(o => {
					return o.saved === 'cloud';
				}).map(o => o.id);
				//let ids = selected.map(o => o.id);

				let onConfirm = async buttonIndex => {
					if (buttonIndex == 1) {
						const localPromises = self.$storage.getItem('yarns-archive')
							.then(result => {
								let yarnsArchive = [];
								if (result) yarnsArchive = result;

								yarnsArchive = yarnsArchive.filter(
									o => !localYarnsIds.includes(o.id)
								);

								return self.$storage.setItem('yarns-archive', yarnsArchive);
							})
							.catch(error => {
								self.$snack.danger({
									button: null,
									text: self.$tc('yarn-delete-error')
								});
							});
						const cloudPromises = cloudYarnsIds.map(async id => {
							await axios.delete(`/yarns/${id}`)
								.then(() => resolve())
								.catch(error => {
									self.$snack.danger({
										button: null,
										text: self.$tc('yarn-delete-error')
									});
								});
						});
						await Promise.all([].concat(localPromises).concat(cloudPromises))
							.then(() => {
								self.$snack.success({
									button: null,
									text: self.$tc(
										'yarn-deleted-successfully',
										(localYarnsIds.length + cloudYarnsIds.length)
									)
								});
								self.$store.dispatch('updateYarnsArchive');
							})
					}
				};
				let message = self.$tc('delete-yarn-confirm', (localYarnsIds.length + cloudYarnsIds.length), {
					count: (localYarnsIds.length + cloudYarnsIds.length)
				});
				if (navigator.notification) {
					navigator.notification.confirm(
						message, // message
						onConfirm, // callback to invoke with index of button pressed
						this.$t('delete-yarn'), // title
						[this.$t('confirm'), this.$t('cancel')] // buttonLabels
					);
				} else {
					if (confirm(message)) onConfirm(1);
				}
			});
		}
	},
	components: {
		FilteredSearch
	},
};
</script>

<style scoped>
.arrow {
	margin-left: .8rem;
}
</style>